import { Box, LinearProgress } from '@mui/material';
import { TournamentStatus } from '@okletsplay/core';
import classNames from 'classnames';
import React, { FC, useMemo } from 'react';
import { useStyles } from './TournamentStatusProgress.styles';

interface TournamentStatusIndicatorProps {
  status: TournamentStatus;
  teamsSize: number;
  minTeamsSize: number;
  maxTeamsSize: number;
}

export const TournamentStatusProgress: FC<TournamentStatusIndicatorProps> = ({
  teamsSize = 0,
  maxTeamsSize = 0,
  minTeamsSize = 0,
  status,
}) => {
  const { classes } = useStyles();

  const progress = useMemo(() => {
    if (!maxTeamsSize) {
      return 0;
    }

    const progressValue = (teamsSize * 100) / maxTeamsSize;
    return Math.min(100, progressValue);
  }, [maxTeamsSize, teamsSize]);

  const isMinTeamsSizeRegistered = useMemo(
    () => teamsSize >= minTeamsSize && status === TournamentStatus.Pending,
    [minTeamsSize, status, teamsSize]
  );

  return (
    <Box className={classes.root}>
      <Box
        className={classNames(classes.progressContainer, {
          live: status === TournamentStatus.Live,
          pending: status === TournamentStatus.Pending,
          checkin: status === TournamentStatus.Checkin,
          [classes.readyToLive]: isMinTeamsSizeRegistered,
          finished: status === TournamentStatus.Finished,
          canceled: status === TournamentStatus.Canceled,
          failed: status === TournamentStatus.Failed,
        })}
      >
        <LinearProgress variant="determinate" value={progress} />
      </Box>
    </Box>
  );
};
